const data = {
	"width": 256,
	"height": 256,
	"body": "<g fill=\"currentColor\"><path d=\"M216 64v128H44V64Z\" opacity=\".2\"/><path d=\"M80 64a8 8 0 0 1 8-8h128a8 8 0 0 1 0 16H88a8 8 0 0 1-8-8Zm136 56H88a8 8 0 1 0 0 16h128a8 8 0 0 0 0-16Zm0 64H88a8 8 0 1 0 0 16h128a8 8 0 0 0 0-16ZM44 52a12 12 0 1 0 12 12a12 12 0 0 0-12-12Zm0 64a12 12 0 1 0 12 12a12 12 0 0 0-12-12Zm0 64a12 12 0 1 0 12 12a12 12 0 0 0-12-12Z\"/></g>"
};
export default data;
